import useSWR from 'swr'
import fetcher from '../utils/fetcher'

const useImporterCountries = (language) => {
    const url = `https://extranet.greentec.eu/api/importers/countries?language=${language}`

    const {data, error} = useSWR(url, fetcher)

    return {
        importerCountries: data,
        importerCountriesLoading: !error && !data,
        importerCountriesError: error
    }
}

export default useImporterCountries